import { styled } from "styled-components";

import { ActionButtonItem, ShareIcon } from "common/components";
import { useDispatch } from "common/utilities/react-redux";
import { useTranslate } from "common/utilities/useTranslate";
import { shareLinkAction } from "domains/share/actions";
import { iconStyle } from "domains/topicDetail/components/actionButtons/iconStyle";
import type { Topic } from "entities/topics/types";

const StyledShareIcon = styled(ShareIcon)`
  ${iconStyle}
`;

type ShareActionButtonProps = { keyIssue?: Topic; topic: Topic };

export const ShareActionButton = ({ topic, keyIssue }: ShareActionButtonProps) => {
  const dispatch = useDispatch();
  const translate = useTranslate();

  const shareHandle = () => {
    let link = `${import.meta.env.VITE_WEBSITE_URL}/topics/${topic.id}`;
    if (keyIssue) {
      link += `/key-issues/${keyIssue.id}`;
    }
    dispatch(
      shareLinkAction({
        id: (keyIssue ?? topic).id,
        type: keyIssue ? "Key Issue" : "Topic",
        name: keyIssue ? `${topic.name}: ${keyIssue.name}` : topic.name,
        link,
        image: topic.images?.thumbnail,
      }),
    );
  };

  return <ActionButtonItem label={translate("app.monitor.share")} icon={<StyledShareIcon />} onClick={shareHandle} />;
};
